<script setup lang="ts">
defineOptions({
	name: 'DataTransfersSection',
})

const { t: $t, locale } = useI18n()
</script>

<template>
	<section class="space-y-7">
		<div class="flex items-center gap-3.5">
			<UIcon
				name="i-solar:global-linear"
				class="size-7 text-[#ED8B00]"
			/>
			<h2 class="text-xl sm:text-2xl font-medium text-gray-900 tracking-tight">
				{{ $t('Data Transfers to Third Countries') }}
			</h2>
		</div>
		<div class="space-y-5 text-base sm:text-[18px] text-[#364153] tracking-[-0.199px] leading-7">
			<p>
				{{
					$t(
						'The Personal Data collected by Gaveta Decimal may be stored and processed in London, UK or in any other country where Gaveta Decimal, its affiliates, subsidiaries, or service providers have operational facilities. The choice of storage locations is determined by principles of operational efficiency, performance improvement, and the creation of redundancies to protect data in the event of disruptions or other issues',
					)
				}}.
			</p>

			<p>
				{{
					$t(
						'Gaveta Decimal is committed to ensuring that the Personal Data collected is processed in accordance with the terms outlined in this Policy and in compliance with the requirements of relevant legislation, irrespective of where the Personal Data is located',
					)
				}}.
			</p>

			<p>
				{{
					$t(
						'In line with this commitment, Gaveta Decimal may transfer Personal Data from the European Economic Area to Third Countries. Should such transfers occur, Gaveta Decimal is dedicated to ensuring that each transfer complies with applicable legal requirements, especially concerning the adequacy assessment of data protection in the destination country and adherence to mandatory standards for such transfers',
					)
				}}.
			</p>

			<p>
				{{
					$t(
						`For more details on the European Commission's decisions regarding the adequacy of Personal Data protection in countries where Gaveta Decimal processes Personal Data, please refer to this link`,
					)
				}}{{ locale === 'fr' ? ' :' : ':' }}
			</p>
			<NuxtLink
				to="https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en"
				target="_blank"
				class="underline text-sky-700"
			>
				https://commission.europa.eu/law/law-topic/data-protection/international-dimension-data-protection/adequacy-decisions_en
			</NuxtLink>
		</div>
	</section>
</template>
